query PracticeOverviewQuery {
  practiceOverview {
    studentId
    lastPracticedAt
    thisWeekMinutes
    trackingEnabled
  }
}
